<template>
  <div class="approvalRecord">
    <el-collapse v-model="activeNames">
      <el-collapse-item name="record">
        <template #title>
          <span>
            <img src="../../assets/svg/approvalRecord.svg" alt="" />
            审批记录
          </span>
        </template>
        <div
          class="block"
          style="max-height: 700px; overflow-y: auto; padding: 5px 0px 5px 26px"
        >
          <el-timeline>
            <el-timeline-item
              v-for="(item, index) in flowRecordList"
              :key="index"
              :icon="setIcon(item.finishTime)"
              :color="setColor(item.finishTime)"
            >
              <div class="taskTitle">
                <p>{{ item.taskName }}</p>
                <editTime
                  v-if="userName == '质量反馈开发'"
                  :taskId="item.taskId"
                ></editTime>
              </div>
              <audit-record-parse
                :datas="item.recordJsonData"
              ></audit-record-parse>
            </el-timeline-item>
          </el-timeline>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>
<script>
import { flowRecord } from "../../api/flowable/finished";
import KdAuditRecordParse from "./kdAuditRecordParse.vue";
import { requestQuestionFlowInsInfoKD } from "@/api/feedbackKD";
import editTime from "@/components/problemDetails/editTime.vue";
export default {
  name: "approvalRecord",
  components: {
    AuditRecordParse: KdAuditRecordParse,
    editTime,
  },
  props: {
    taskId: {
      type: String,
      default: "",
    },
    questionId: {
      type: String,
      default: "",
    },
  },
  provide() {
    return {
      loadTaskDetail: this.loadTaskDetail,
    };
  },

  data() {
    return {
      proInstanceId: "",
      deployId: "",
      activeNames: ["record"], // 全部展开
      flowRecordList: [],
      testRecordList: [
        {
          taskName: "测试",
          variableJsonData: [
            {
              name: "测试",
              type: "str",
              value: "测试显示效果",
            },
            {
              name: "故障车VIN码",
              type: "vins",
              value: [
                {
                  vin: "WBACB1EB1DH000000",
                  orderNum: "2021-01-01",
                  info: "测试信息",
                  manufactureDate: "2021-01-01",
                },
                {
                  vin: "WBACB1EB1DH000000",
                  orderNum: "2021-01-01",
                  info: "测试信息",
                  manufactureDate: "2021-01-01",
                },
              ],
            },
            {
              name: "附件",
              type: "resources",
              value: [
                {
                  type: "image",
                  fileName: "图片.png",
                  filePath: "https://picsum.photos/200/300",
                },
                {
                  type: "video",
                  fileName: "视频.mp4",
                  filePath: "https://www.w3schools.com/html/mov_bbb.mp4",
                },
              ],
            },
          ],
        },
        {
          taskName: "测试2",
          variableJsonData: [
            {
              name: "测试",
              type: "str",
              value: "测试显示效果",
            },
            {
              name: "故障车VIN码",
              type: "vins",
              value: [
                {
                  vin: "WBACB1EB1DH000000",
                  orderNum: "2021-01-01",
                  info: "测试信息",
                  manufactureDate: "2021-01-01",
                },
                {
                  vin: "WBACB1EB1DH000000",
                  orderNum: "2021-01-01",
                  info: "测试信息",
                  manufactureDate: "2021-01-01",
                },
              ],
            },
            {
              name: "附件",
              type: "resources",
              value: [
                {
                  type: "image",
                  fileName: "图片.png",
                  filePath: "https://picsum.photos/200/300",
                },
                {
                  type: "video",
                  fileName: "视频.mp4",
                  filePath: "https://www.w3schools.com/html/mov_bbb.mp4",
                },
              ],
            },
            {
              name: "临时措施",
              type: "array",
              value: [
                {
                  name: "测试",
                  type: "str",
                  value: "测试显示效果",
                },
                {
                  name: "故障车VIN码",
                  type: "vins",
                  value: [
                    {
                      vin: "WBACB1EB1DH000000",
                      orderNum: "2021-01-01",
                      info: "测试信息",
                      manufactureDate: "2021-01-01",
                    },
                    {
                      vin: "WBACB1EB1DH000000",
                      orderNum: "2021-01-01",
                      info: "测试信息",
                      manufactureDate: "2021-01-01",
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
      userName: "",
    };
  },
  methods: {
    /** 流程流转记录 */
    getFlowRecordList(procInsId, deployId) {
      const that = this;
      const params = { procInsId: procInsId, deployId: deployId };
      flowRecord(params)
        .then((res) => {
          //that.flowRecordList = that.testRecordList
          let dataList = res.data.data.flowList;
          for (let i = 0; i < dataList.length; i++) {
            let dataListElement = dataList[i];
            let commentElement = dataListElement.comment[0];
            if (commentElement) {
              dataListElement.recordJsonData = JSON.parse(
                commentElement.comment
              );
            } else {
              dataListElement.recordJsonData = [];
            }
          }
          that.flowRecordList = dataList;
        })
        .catch((res) => {
          // this.goBack();
        });
    },
    loadTaskDetail() {
      let questionId = this.questionId;
      let _this = this;
      let searchParam = new URLSearchParams();
      searchParam.append("questionId", questionId);
      requestQuestionFlowInsInfoKD(searchParam).then((res) => {
        if (res.status == "0") {
          _this.proInstanceId = res.data.procInsId;
          _this.deployId = res.data.deployId;
          _this.getFlowRecordList(this.proInstanceId, this.deployId);
        } else {
          _this.$DonMessage.error(res.data.message);
        }
      });
    },
    setIcon(val) {
      if (val) {
        return "";
      } else {
        return "";
      }
    },
    setColor(val) {
      if (val) {
        return "";
      } else {
        return "";
      }
    },
  },
  mounted() {
    this.loadTaskDetail();
    this.userName = sessionStorage.getItem("name");
  },
};
</script>
<style scoped>
.taskTitle {
  display: flex;
  align-items: center;
}
.taskTitle > p {
  font-weight: bold;
  line-height: 1.5;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
